<template>
  <header class="" v-if="!isPublic && !isAdminRoute && !isAuthRoute">

    <nav class="hidden md:flex items-center min-h-[80px] bg-white border-b border-[#E6E2E7] text-sm" :class="{ 'nav--dark': isProfileSection }">

      <div class="w-full px-4 py-1">
        <div class="flex items-center justify-between w-full">
          <router-link :to="{ name: 'admin-applicants' }" class="flex items-center gap-2 no-underline bg-transparent text-primary py-0" rel="home" title="" itemprop="url">
            <img src="/static/images/unicorn.png" alt="Logo" width="48" class="rounded-full">
            <strong>Unicorn Visa</strong>
          </router-link>
          <ul class="list-none m-0">
            <li class="inline mr-[30px]"><router-link v-if="user && user.isAdmin" :to="{ name: 'admin-bodies' }" class="nav-link" :class="{ 'nav-link--active': isAdminSection }">Admin</router-link></li>
            <li class="inline mr-[30px]"><router-link v-if="user && (user.isAdmin || user.isManager)" :to="{ name: 'admin-applicants' }" class="nav-link" :class="{ 'nav-link--active': isAdminApplicantsSection }">Applicants</router-link></li>
          </ul>

          <div class="text-right" v-if="!isLogged">
            <ul class="list-none m-0">
              <li class="inline mr-[30px]">
                <router-link :to="{ name: 'login' }" class="nav-link">Log in</router-link>
              </li>
              <li class="inline mr-[30px]">
                <router-link :to="{ name: 'register' }" class="nav-link">Sign up</router-link>
              </li>
            </ul>
          </div>
          <div class="text-right" v-else>
            <ul class="list-none m-0 pl-0">
              <li class="inline">
                <a href="#" @click.prevent="logout()" class="nav-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                Sign out</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </nav>
  </header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'app-header',
  data () {
    return {
      showAccountModal: false
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('LOGOUT')
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    isLogged () {
      if (this.$store.state.auth.user) {
        return this.$store.state.auth.user.id
      }
    },
    isProfileSection () {
      return this.$route.name.startsWith('profile')
    },
    isAdminApplicantsSection () {
      return this.$route.name.startsWith('admin-applicants')
    },
    isAdminContactsSection () {
      return this.$route.name.startsWith('admin-contacts')
    },
    isAdminSection () {
      return this.$route.name.startsWith('admin-bodies')
    },
    isPublic () {
      return this.$route.name && this.$route.name.startsWith('public')
    },
    isAdminRoute () {
      return this.$route.name && this.$route.name.startsWith('admin')
    },
    isAuthRoute () {
      const name = this.$route.name
      return name && (name === 'login' || name === 'register' || name === 'reset')
    },
    isAdminTasksSection () {
      return this.$route.name.startsWith('admin-tasks')
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.nav-link {
  color: #7D7480;
  font-weight: 600;
  text-decoration: none;
}

.nav-link--active,
.nav-link.router-link-exact-active {
  color: #7c5bea;
  position: relative;
}

.nav-link--active::after,
.nav-link.router-link-exact-active::after {
  content: "\2022";
  position: absolute;
  top: 15px;
  left: 50%;
  width: 4px;
  margin-left: -2px;
  color: #7c5bea;
}

.nav--dark {
  background: #0E245A !important;
  border-color: #0E245A !important;
}

.nav--dark .nav-link {
  color: #fff;
}
</style>
